<template>
  <div class="container mt-5">
    <div v-if="loading" class="text-center">
      <div class="spinner-border text-light" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-if="!loading && chronicle">
      <div class="row">
        <div class="col-md-4">
          <img :src="chronicle.cover_image_path || '/img/default-cover.jpg'" class="img-fluid rounded" alt="Cover Image">
        </div>
        <div class="col-md-8">
          <h1 class="sect-title">{{ chronicle.title }}</h1>
          <p class="text-muted">{{ chronicle.synopsis }}</p>
          <ul class="list-unstyled">
            <li><strong>Autor:</strong> {{ chronicle.author_name || 'Desconhecido' }}</li>
            <li><strong>Cidade:</strong> {{ chronicle.city }}</li>
            <li><strong>Era:</strong> {{ chronicle.era }}</li>
            <li><strong>Sistema:</strong> {{ chronicle.system }}</li>
            <li><strong>Status:</strong>
              <span :class="['badge', chronicle.status === 'finished' ? 'bg-success' : 'bg-warning']">
                {{ chronicle.status === 'finished' ? 'Finalizada' : 'Em Andamento' }}
              </span>
            </li>
          </ul>
          <button v-if="isAuthor" class="btn btn-vampire" @click="goToEditChronicle">
            <i class="bi bi-pencil-fill me-2"></i>
            Editar Crônica
          </button>
        </div>
      </div>

      <hr class="my-5">

      <h2>Capítulos</h2>
      <div v-for="chapter in chronicle.chapters" :key="chapter.id" class="card chapter-card mb-4">
        <div class="card-body">
          <h5 class="card-title">{{ chapter.title }}</h5>
          <div class="card-text" v-html="chapter.content"></div>
          <!-- Add other chapter details here -->
        </div>
      </div>

      <div class="mt-4">
          <button class="btn btn-outline-light" @click="goToChroniclesList">
            <i class="bi bi-arrow-left me-2"></i>
            Voltar para a Lista
          </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  name: 'ChronicleDetailView',
  props: {
    currentUser: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      chronicle: null,
      loading: true,
    };
  },
  computed: {
    isAuthor() {
      return this.currentUser && this.chronicle && this.currentUser.id === this.chronicle.user_id;
    },
  },
  async created() {
    await this.fetchChronicle();
  },
  methods: {
    async fetchChronicle() {
      this.loading = true;
      try {
        const { data } = await api.get(`/chronicles/${this.$route.params.id}`);
        this.chronicle = data;
      } catch (error) {
        console.error('Failed to fetch chronicle:', error);
      } finally {
        this.loading = false;
      }
    },
    goToEditChronicle() {
      if (!this.chronicle || !this.chronicle.id) {
        return;
      }
      this.$router.push(`/cronicas/${this.chronicle.id}/editar`);
    },
    goToChroniclesList() {
      this.$router.push('/cronicas');
    }
  },
};
</script>

<style scoped>
.chapter-card {
  background-color: var(--vampire-gray);
  border-color: var(--vampire-red);
}
</style>
